<template>
  <div>
    <template v-if="!item.children">
      <el-menu-item :index="item.name">
        {{ item.name }}
      </el-menu-item>
    </template>
    <el-submenu :index="item.name" v-else>
      <template slot="title">
        {{ item.name }}
      </template>
      <submenu-item
          v-for="(v, i) in item.children"
          :key="v.name + i"
          :item="v"
          :base-path="v.name"
      />
    </el-submenu>
  </div>
</template>
<script>
export default {
  name: "submenuItem",
  data() {
    return {};
  },
  props: {
    item: {
      typeof: Object,
      default: () => {},
    },
    // base-path 传参数多余的东西
    basePath: {
      type: String,
      default: "",
    },
  },
};
</script>
